<h2>Editing Provisional School Information</h2>
<form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="triggerConfirmPopover($event)" class="form"
	*ngIf="!saved">

	<div class="row">

		<!-- SCHOOL NAME -->
		<div class="col-12">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>School Name</mat-label>
				<input matInput type="text" formControlName="SCHOOL_NAME" placeholder="School Name" />

				<mat-error *ngIf="submitted && form.get('SCHOOL_NAME')?.hasError('required')">
					School Name required.
				</mat-error>
			</mat-form-field>
		</div>

		<!-- DISTRICT -->
		<div class="col-12">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>School District</mat-label>
				<input matInput type="text" formControlName="DISTRICT" placeholder="School District" />

				<mat-error *ngIf="submitted && form.get('DISTRICT')?.hasError('required')">
					School District required.
				</mat-error>
			</mat-form-field>
		</div>

	</div>

	<!-- ADDRESS -->
	<div class="row">

		<!-- STREET 1 -->
		<div class="col-md-6">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>Street Address 1</mat-label>
				<input matInput formControlName="STREET_ADDRESS_1" placeholder="Work Address 1" maxlength="100" />

				<mat-error *ngIf="submitted && form.get('STREET_ADDRESS_1')?.hasError('required')">
					Street Address required.
				</mat-error>
			</mat-form-field>
		</div>

		<!-- STREET 2 -->
		<div class="col-md-6">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>Street Address 2</mat-label>
				<input matInput formControlName="STREET_ADDRESS_2" placeholder="Work Address 2" maxlength="100" />
			</mat-form-field>
		</div>

		<!-- CITY -->
		<div class="col-md-6">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>City</mat-label>
				<input matInput formControlName="CITY" placeholder="City" />

				<mat-error *ngIf="submitted && form.get('CITY')?.hasError('required')">
					City required.
				</mat-error>
			</mat-form-field>
		</div>

		<!-- ZIP -->
		<div class="col-md-6">
			<mat-form-field appearance="fill" class="w-100">
				<mat-label>ZIP code</mat-label>
				<input matInput formControlName="ZIPCODE" placeholder="ZIP code" />

				<mat-error *ngIf="submitted && form.get('ZIPCODE')?.hasError('required')">
					ZIP code required.
				</mat-error>
			</mat-form-field>
		</div>

	</div>

	<div class="row" id="messageId">
		<div class="col-12" *ngIf="!saving">

			<confirm-popover #savePopover class="margin-right-sm" [type]="'button'" [buttonTxt]="'Save'"
				[popoverMsg]="'Are you sure you want to update this provisional school information?'"
				[color]="'primary'" (onConfirm)="onSubmit()" [disabled]="!form.valid || saving" [(isLoading)]="saving">
			</confirm-popover>


			<button mat-raised-button color="accent" (click)="cancel()">
				Cancel
			</button>
		</div>

		<div class="col-12" *ngIf="!saving">
			<div *ngIf="!saved && showMessage">
				<app-msg *ngIf="msg && msg.MSG" [msg]="msg"></app-msg>
			</div>
		</div>
	</div>

</form>